<template>
  <div class="container home">
    <div class="color-block"></div>

    <div class="row">
      <div
        class="img col-lg-3 bg position-fixed d-none d-lg-block hero-img"
      ></div>
      <div
        class="col-12 col-lg-8 offset-lg-4 home-details text-center text-lg-start"
      >
        <div>
          <img
            src="@/assets/ibrahim.jpg"
            class="img-fluid main-img-mobile d-sm-block d-lg-none"
            alt="hero man"
          />
          <h1 class="text-uppercase poppins-font align-middle">
            I'M IBRAHIM mosstafa
            <typewriter
              :replace="replace"
              :type-interval="100"
              :replace-interval="1000"
            >
              <span>Front end Developer</span>
            </typewriter>
          </h1>
          <p>
            I'm a front‑end developer focused on crafting clean
            user‑friendly experiences, I am passionate about building excellent
            software that improves the lives of those around me.
          </p>
          <router-link to="/about">
            <button class="button">
              <span class="button-text"> about me</span
              ><span class="button-icon"
                ><font-awesome-icon
                  icon="fa-solid fa-arrow-right"
                  size="lg"
                  color="#ddd"
              /></span>
            </button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Typewriter from "typewriter-vue";
export default {
  name: "HomeView",
  components: { Typewriter },
  data: () => ({
    replace: [
      { from: "Vue", to: "React?" },
      { from: "Typewriter React?", to: "Joking, it`s Vue!" },
    ],
  }),
};
</script>
